import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {OfferWidgetsRoutingModule} from "./offer-widgets-routing.module";
import {SharedModule} from "../shared/shared.module";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {FelloUiLibModule, SignatureModule} from "fello-common";
import {FormsModule} from "@angular/forms";
import {SearchWidgetComponent} from "./components/search-widget/search-widget.component";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {WidgetTextDirective} from "./directives/widget-text.directive";
import {OfferFlowModule} from "../offer-flow/offer-flow.module";
import {NgxSpinnerModule} from "ngx-spinner";
import {MatSnackBarModule} from "@angular/material/snack-bar";

@NgModule({
  declarations: [SearchWidgetComponent, WidgetTextDirective],
  imports: [
    CommonModule,
    SharedModule,
    OfferWidgetsRoutingModule,
    MatAutocompleteModule,
    FelloUiLibModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    SignatureModule,
    OfferFlowModule,
    NgxSpinnerModule,
    MatSnackBarModule
  ]
})
export class OfferWidgetsModule {}
